const menuItems = document.querySelectorAll(".menu-item");
const desktopContent = document.querySelector(".desktop-content");

const labels = document.querySelectorAll(".plusminus");
labels.forEach((label) => {
  label.addEventListener("click", (e) => {
    e.stopPropagation();
  });
});

function populateMobileContent(item) {
  const mobileContent = item.querySelector(".menu-item__mobile-content");
  if (mobileContent) {
    mobileContent.innerHTML = `
      ${item.dataset.copy}
      <div class="menu-item__image" style="background-image: url('${item.dataset.image}');"></div>
    `;
  }
}

function updateDesktopContent(item) {
  desktopContent.innerHTML = `
    ${item.dataset.copy}
    <div class="menu-item__image" style="background-image: url('${item.dataset.image}');"></div>
  `;
}

menuItems.forEach((item) => {
  populateMobileContent(item);

  item.addEventListener("click", (e) => {
    const isLabelClicked = e.target.closest(".plusminus");
    if (isLabelClicked) return;

    const checkbox = item.querySelector(".menu-item__checkbox");
    const mobileContent = item.querySelector(".menu-item__mobile-content");
    const isActive = item.classList.contains("active");
    const isVisible = mobileContent.classList.contains("visible");

    if (isActive && window.innerWidth >= 769) return;

    if (!isActive) {
      updateDesktopContent(item);
      menuItems.forEach((item) => item.classList.remove("active"));
      item.classList.add("active");
    }

    document
      .querySelectorAll(".menu-item__mobile-content")
      .forEach((content) => content.classList.remove("visible"));

    document
      .querySelectorAll(".menu-item__checkbox")
      .forEach((checkbox) => (checkbox.checked = false));

    if (!isVisible) {
      mobileContent.classList.add("visible");
      checkbox.checked = true;
    }
  });
});

const firstItem = menuItems[0];
firstItem.classList.add("active");
updateDesktopContent(firstItem);

const firstMobileContent = firstItem.querySelector(
  ".menu-item__mobile-content"
);
const firstCheckbox = firstItem.querySelector(".menu-item__checkbox");
firstMobileContent.classList.add("visible");
firstCheckbox.checked = true;
